import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { SapDocumentTypeService } from '../proxy/controlling/controllers/sap-document-type.service';
import { ServiceMasterService } from '../proxy/controlling/controllers/service-master.service';
import { AccountService } from '../proxy/controlling/controllers/account.service';
import { SapAmountTypeService } from '../proxy/controlling/controllers/sap-amount-type.service';
import { CostCenterService } from '../proxy/controlling/controllers/cost-center.service';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { InternalOrderService } from '../proxy/controlling/controllers/internal-order.service';
FieldBuilder.setNamespace('Controlling');

export const SAPSERVICEENTRYSHEETPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('documentTypeId', 'Entity.SapDocumentType', SapDocumentTypeService)
    .displayFromNested('sapDocumentType.name')
    .sortBy('sapDocumentType.name')
    .build(),
  FieldBuilder.foreignKey('serviceMasterId', 'Entity.ServiceMaster', ServiceMasterService)
    .displayFromNested('serviceMaster.name')
    .sortBy('serviceMaster.name')
    .build(),
  FieldBuilder.foreignKey('accountId', 'Entity.Account', AccountService)
    .displayFromNested('account.name')
    .sortBy('account.name')
    .build(),
  FieldBuilder.checkbox('hasAssignment', 'Entity.SapServiceEntrySheetParameter.HasAssignment')
    .build(),
  FieldBuilder.foreignKey('amountTypeId', 'Entity.SapAmountType', SapAmountTypeService)
    .display('description')
    .keyField('id')
    .build(),
  FieldBuilder.checkbox('hasCostCenter', 'Entity.SapServiceEntrySheetParameter.HasCostCenter')
    .build(),
  FieldBuilder.checkbox('hasWbsElement', 'Entity.SapServiceEntrySheetParameter.HasWbsElement')
    .build(),
  FieldBuilder.checkbox('hasInternalOrder', 'Entity.SapServiceEntrySheetParameter.HasInternalOrder')
    .build(),
  FieldBuilder.foreignKey('costCenterId', 'Entity.CostCenter', CostCenterService)
    .displayFromNested('costCenter.sapCode')
    .sortBy('costCenter.sapCode')
    .build(),
  FieldBuilder.foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name')
    .sortBy('wbs.name')
    .build(),
  FieldBuilder.foreignKey('internalOrderId', 'Entity.InternalOrder', InternalOrderService)
    .displayFromNested('internalOrder.name')
    .sortBy('internalOrder.name')
    .build(),
];

export const SAPSERVICEENTRYSHEETPARAMETER_CONFIG = {
  entityName: 'SapServiceEntrySheetParameter',
  localizationKey: 'Controlling::Entity.SapServiceEntrySheetParameter',
  fields: SAPSERVICEENTRYSHEETPARAMETER_FIELDS,
  permission: 'ControllingSap.SapServiceEntrySheetParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
